const initialState = {
  auth: null,
  token: '',
  lastUpdate: null,
};

const authSlice = (set) => ({
  ...initialState,
  setAuth: (auth) => set({ auth, token: auth.token }),
  resetAuth: () => set(initialState),
});

export default authSlice;
